import { ReactNode } from "react";
import { OptionType } from "../constants";
import { InputLabel } from "../../../constants/Styles";
import RadioButton from "../../common/RadioButton";
import { Container } from "./FormikRadioOptionsStyles";
import { useField, useFormikContext } from "formik";

export default function FormikRadioOptions<OptionValue>({
  name,
  label,
  options,
  disabled = false,
}: {
  name: string;
  label?: ReactNode;
  options: OptionType<OptionValue>[];
  disabled?: boolean;
}) {
  const [field] = useField(name);
  const value = field.value as string;
  const { setFieldValue } = useFormikContext();

  const selectValue = (newValue: OptionValue) => {
    if (!disabled) {
      void setFieldValue(name, newValue);
    }
  };

  return (
    <Container>
      {label && <InputLabel>{label}</InputLabel>}
      <div>
        {options.map((option, optionIndex) => {
          return (
            <RadioButton
              key={optionIndex.toString() + option.label}
              label={option.label}
              onChange={() => selectValue(option.value)}
              checked={value == option.value}
            />
          );
        })}
      </div>
    </Container>
  );
}
